var render = function render(){
  var _vm$data, _vm$data3, _vm$data4, _vm$data4$pagination, _vm$data5, _vm$data5$pagination, _vm$data6, _vm$data6$pagination;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row list-view"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12 list-view-filter",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_c('div', {
    staticClass: "h-filter-item",
    staticStyle: {
      "min-width": "40px",
      "width": "fit-content"
    }
  }, [_c('div', {
    staticClass: "filter-action filter-af"
  }, [_vm.checkoutPermission('CREATE_DELIVERY_FEE_BRANCH') ? _c('button', {
    staticClass: "btn btn-success btn-sm ah mt8",
    on: {
      "click": function ($event) {
        return _vm.linkPage('CreateDeliveryFeeBranch');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")]) : _vm._e()])])])]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w70 txt-center"
  }, [_vm._v("No")]), _c('th', {
    attrs: {
      "width": "150px"
    }
  }, [_vm._v("Branch")]), _c('th', {
    attrs: {
      "width": "300px"
    }
  }, [_vm._v("Branch Code")]), _c('th', {
    attrs: {
      "width": "100px"
    }
  }, [_vm._v("Description")]), _vm.checkoutPermission('UPDATE_DELIVERY_FEE_BRANCH') || _vm.checkoutPermission('DELETE_DELIVERY_FEE_BRANCH') ? _c('th', {
    staticClass: "w100 txt-center"
  }, [_vm._v(" Action ")]) : _vm._e()])]), _vm.checkoutPermission('VIEW_DELIVERY_FEE_BRANCH') ? _c('tbody', _vm._l((_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : _vm$data.items, function (item, index) {
    var _vm$data2, _vm$data2$pagination;
    return _c('tr', {
      key: (item, index),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(" " + _vm._s(String((((_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : (_vm$data2$pagination = _vm$data2.pagination) === null || _vm$data2$pagination === void 0 ? void 0 : _vm$data2$pagination.offset) || 0) + index + 1).padStart(3, '0')) + " ")]), _c('td', {
      staticClass: "desc"
    }, [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : item.name) || "N/A"))]), _c('td', [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : item.code) || "N/A"))]), _c('td', [_vm._v(_vm._s((item === null || item === void 0 ? void 0 : item.description) || "N/A"))]), _vm.checkoutPermission('UPDATE_DELIVERY_FEE_BRANCH') || _vm.checkoutPermission('DELETE_DELIVERY_FEE_BRANCH') ? _c('td', {
      staticClass: "txt-center"
    }, [_vm.checkoutPermission('UPDATE_DELIVERY_FEE_BRANCH') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'EditDeliveryFeeBranch',
          query: {
            id: item === null || item === void 0 ? void 0 : item.id
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs h36"
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })])]) : _vm._e(), _vm.checkoutPermission('DELETE_DELIVERY_FEE_BRANCH') ? _c('button', {
      staticClass: "btn btn-danger btn-xs h36 ml3",
      on: {
        "click": function ($event) {
          return _vm.popupModalDelete(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1) : _vm._e()]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), !_vm.isFetching && ((_vm$data3 = _vm.data) === null || _vm$data3 === void 0 ? void 0 : _vm$data3.items.length) <= 0 ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li go-left"
  }, [_vm._v("Total : " + _vm._s((_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : (_vm$data4$pagination = _vm$data4.pagination) === null || _vm$data4$pagination === void 0 ? void 0 : _vm$data4$pagination.total))]), (_vm$data5 = _vm.data) !== null && _vm$data5 !== void 0 && (_vm$data5$pagination = _vm$data5.pagination) !== null && _vm$data5$pagination !== void 0 && _vm$data5$pagination.totalPage ? _c('Pagination', {
    attrs: {
      "pagination": (_vm$data6 = _vm.data) === null || _vm$data6 === void 0 ? void 0 : (_vm$data6$pagination = _vm$data6.pagination) === null || _vm$data6$pagination === void 0 ? void 0 : _vm$data6$pagination.totalPage
    }
  }) : _vm._e()], 1)])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    staticStyle: {
      "width": "75px"
    },
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    staticStyle: {
      "width": "75px"
    }
  }, [_vm._v(" Loading... ")]), _c('button', {
    staticClass: "btn btn-light-secondary btn-xs go-right mr12",
    staticStyle: {
      "width": "75px"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left"
  }, [_c('b', [_vm._v("All Branchs")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }